import {
  Form,
  Button,
  Tabs,
  Upload,
  InputNumber,
  Input,
  Select,
  message,
  Space,
} from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const StepPrizeSetting = ({
  form1,
  form2,
  activePoolIndex,
  setActivePoolIndex,
  activePrizeTabs,
  setActivePrizeTabs,
  next,
  prev,
  customImageUpload,
}: any) => {
  const allPools = Form.useWatch('lottoPools', form2) || [];
  return (
    <Form form={form2}>
      <Form.List name="lottoPools">
        {(pools, { add: addPool, remove: removePool }) => (
          <div style={{ display: 'flex', height: 700 }}>
            {/* 左侧奖池列表 */}
            <div
              style={{
                width: 140,
                background: '#f5f5f5',
                borderRadius: 4,
                padding: 8,
                overflowY: 'auto',
                border: '1px solid #d9d9d9',
              }}
            >
              {pools.map((pool, index) => (
                <div
                  key={index}
                  style={{
                    background: activePoolIndex === index ? '#e6f7ff' : '#fff',
                    padding: '8px 12px',
                    marginBottom: 8,
                    borderRadius: 4,
                    cursor: 'pointer',
                    border: '1px solid #d9d9d9',
                    position: 'relative',
                    fontSize: 14,
                  }}
                  onClick={() => setActivePoolIndex(index)}
                >
                  奖池{index + 1}
                  {form1.getFieldValue('type') === 0 && pools.length > 1 && (
                    <DeleteOutlined
                      onClick={(e) => {
                        e.stopPropagation();
                        removePool(index);
                        setActivePoolIndex((prev: number) =>
                          prev === index ? 0 : prev > index ? prev - 1 : prev
                        );
                      }}
                      style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#999',
                        fontSize: 12,
                      }}
                    />
                  )}
                </div>
              ))}
              {form1.getFieldValue('type') === 0 && pools.length < 10 && (
                <Button
                  type="text"
                  icon={<PlusOutlined />}
                  style={{ width: '100%' }}
                  onClick={() => {
                    addPool({ prizeList: [{}, {}] });
                    setActivePoolIndex(pools.length);
                  }}
                >
                  添加奖池
                </Button>
              )}
            </div>

            {/* 右侧奖池内容（所有奖池都渲染，非激活的隐藏） */}
            <div
              style={{
                flex: 1,
                marginLeft: 24,
                overflowY: 'auto',
                paddingRight: 8,
                height: '100%',
              }}
            >
              {pools.map((pool, poolIndex) => (
                <div
                  key={pool.key}
                  style={{
                    display: poolIndex === activePoolIndex ? 'block' : 'none',
                  }}
                >
                  {/* 参与条件 */}
                  {form1.getFieldValue('type') === 0 && (
                    <div
                      style={{
                        background: '#f6ffed',
                        border: '1px solid #b7eb8f',
                        padding: '12px 16px',
                        marginBottom: 24,
                        borderRadius: 4,
                      }}
                    >
                      <Form.Item
                        label="参与条件"
                        name={[pool.name, 'gashaponNum']}
                        rules={[{ required: true, message: '请输入参与条件' }]}
                        style={{ marginBottom: 0 }}
                      >
                        <InputNumber
                          min={0}
                          addonAfter="券/人"
                          style={{ width: 300 }}
                          precision={0}
                        />
                      </Form.Item>
                    </div>
                  )}

                  {/* 奖品 Tabs */}
                  <Form.List name={[pool.name, 'prizeList']}>
                    {(fields, { add, remove }) => (
                      <Tabs
                        type="card"
                        activeKey={
                          activePrizeTabs[poolIndex] ??
                          String(fields[0]?.key ?? '0')
                        }
                        onChange={(key) =>
                          setActivePrizeTabs((prev: any) => ({
                            ...prev,
                            [poolIndex]: key,
                          }))
                        }
                        tabBarExtraContent={
                          <Button
                            type="text"
                            icon={<PlusOutlined />}
                            onClick={() => {
                              if (fields.length >= 15) {
                                message.warning('每个奖池最多可配置15个奖品');
                                return;
                              }
                              add({}, (newField) => {
                                setTimeout(() => {
                                  setActivePrizeTabs((prev: any) => ({
                                    ...prev,
                                    [poolIndex]: String(newField.key),
                                  }));
                                }, 0);
                              });
                            }}
                          >
                            添加奖品
                          </Button>
                        }
                      >
                        {fields.map((field, prizeIdx) => (
                          <Tabs.TabPane
                            key={String(field.key)}
                            tab={
                              <span>
                                奖品{prizeIdx + 1}
                                {fields.length > 2 && (
                                  <DeleteOutlined
                                    style={{ marginLeft: 8, color: '#999' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const deletedKey = field.key;
                                      remove(field.name);
                                      if (
                                        String(deletedKey) ===
                                        activePrizeTabs[poolIndex]
                                      ) {
                                        setTimeout(() => {
                                          const newFields = fields.filter(
                                            (f) => f.key !== deletedKey
                                          );
                                          setActivePrizeTabs((prev: any) => ({
                                            ...prev,
                                            [poolIndex]: String(
                                              newFields[0]?.key ?? ''
                                            ),
                                          }));
                                        }, 0);
                                      }
                                    }}
                                  />
                                )}
                              </span>
                            }
                            forceRender
                          >
                            <Form.Item
                              label="奖品类型"
                              name={[field.name, 'prizeType']}
                              rules={[{ required: true }]}
                            >
                              <Select
                                placeholder="请选择奖品类型"
                                style={{ width: 300 }}
                              >
                                <Select.Option value={1}>实物</Select.Option>
                                <Select.Option value={2}>
                                  虚拟商品
                                </Select.Option>
                                <Select.Option value={3}>门票</Select.Option>
                                <Select.Option value={4}>卡券</Select.Option>
                                {/* <Select.Option value={6}>积分</Select.Option> */}
                              </Select>
                            </Form.Item>

                            <Form.Item
                              label="奖品名称"
                              name={[field.name, 'prizeName']}
                              rules={[{ required: true }]}
                            >
                              <Input
                                placeholder="请输入奖品名称"
                                maxLength={20}
                                showCount
                                style={{ width: 300 }}
                              />
                            </Form.Item>

                            {/* {form2.getFieldValue([
                              'lottoPools',
                              poolIndex,
                              'prizeList',
                              prizeIdx,
                              'prizeType',
                            ]) === 6 && (
                              <Form.Item
                                label="积分数量"
                                name={[field.name, 'pointsNum']}
                                rules={[
                                  { required: true },
                                  {
                                    validator: (_, value) =>
                                      Number.isInteger(value)
                                        ? Promise.resolve()
                                        : Promise.reject(),
                                  },
                                ]}
                              >
                                <InputNumber
                                  min={1}
                                  precision={0}
                                  placeholder="请输入整数积分数量"
                                  style={{ width: 300 }}
                                />
                              </Form.Item>
                            )} */}

                            <Form.Item
                              label="奖品图片"
                              name={[field.name, 'prizeImage']}
                              rules={[
                                {
                                  required: true,
                                  message: '请上传奖品图片',
                                },
                                {
                                  validator: async (_, value) => {
                                    if (!value || value.length === 0) return;
                                    const file = value[0];
                                    const hasUrl =
                                      file?.response?.url ||
                                      file?.url ||
                                      file?.thumbUrl;
                                    if (!hasUrl) {
                                      throw new Error('图片上传未完成或无效');
                                    }
                                  },
                                },
                              ]}
                            >
                              <Upload
                                listType="picture-card"
                                maxCount={1}
                                accept="image/jpeg,image/png,image/jpg"
                                customRequest={customImageUpload}
                                fileList={form2.getFieldValue([
                                  'lottoPools',
                                  poolIndex,
                                  'prizeList',
                                  prizeIdx,
                                  'prizeImage',
                                ])}
                                onChange={({ fileList }) => {
                                  form2.setFields([
                                    {
                                      name: [
                                        'lottoPools',
                                        poolIndex,
                                        'prizeList',
                                        prizeIdx,
                                        'prizeImage',
                                      ],
                                      value: fileList,
                                    },
                                  ]);
                                }}
                              >
                                + Upload
                              </Upload>
                              <div
                                style={{
                                  marginTop: 6,
                                  color: 'rgba(0,0,0,0.45)',
                                }}
                              >
                                请上传图片作为奖品图片，建议尺寸小于260*260px，支持.JPG/.JPEG/.PNG格式，大小不超过10M。
                              </div>
                            </Form.Item>

                            <Form.Item
                              label="中奖限制"
                              name={[field.name, 'winLimit']}
                              rules={[{ required: true }]}
                            >
                              <InputNumber
                                min={1}
                                addonAfter="次/人"
                                style={{ width: 300 }}
                                precision={0}
                              />
                            </Form.Item>
                          </Tabs.TabPane>
                        ))}
                      </Tabs>
                    )}
                  </Form.List>
                </div>
              ))}

              {/* 按钮区域 */}
              <Space style={{ marginTop: 24 }}>
                <Button onClick={prev}>上一步</Button>
                <Button type="primary" onClick={next}>
                  下一步
                </Button>
              </Space>
            </div>
          </div>
        )}
      </Form.List>
    </Form>
  );
};

export default StepPrizeSetting;
